/**
 * Guide content for version 2.9 (taksoai-app@2.9.x).
 *
 * Same content as 2.8 — version bumped to re-trigger the onboarding popup
 * for users whose browser had already cached the 2.8 seen-flag.
 */

import type { GuideStep } from './types';

export const GUIDE_STEPS_V29: GuideStep[] = [
  // ─── Step 0 — Insulation Feature Welcome ──────────────────────────────────
  {
    id: 'insulation-welcome',
    index: 0,
    type: 'modal',
    routeScope: 'home',
    hideBack: true,
    title: "What's New in 2.9 — Insulation",
    description:
      '<p>🎉 <strong>Insulation is now fully released!</strong> You can now specify insulation properties on duct and pipe segments directly from the drawing canvas.</p>' +
      '<p>Here is what you can do with the new Insulation feature:</p>' +
      '<ul>' +
      '<li>Assign insulation to any duct or pipe segment from the symbol detail panel.</li>' +
      '<li>Set insulation thickness and material type per segment or across a group.</li>' +
      '<li>Bulk-update insulation settings across an entire zone or system in one action.</li>' +
      '<li>Export insulation data as part of your standard takeoff report.</li>' +
      '<p>Look for the Insulation section in the symbol detail panel to get started.</p>' +
      '<p>If you have any questions, or want a walk through on the new features please reach out to: William Chiykowski (wchiykowski@taksoai.com)</p>' +
      '</ul>',
  },
];
